@if (colorOptions.length) {
@if (title) {
<h3 class="p2">{{title | translate}}</h3>
}

<div class="_horse-color-selector m-t-5">
    <swiper [slidesPerView]="'auto'"
            [spaceBetween]="16"
            [freeMode]="true"
            class="_color-carousel">
        @for (option of colorOptions; track option) {
        <ng-template swiperSlide>
            <div class="_color-option"
                 [class._selected]="isColorSelected(option)"
                 (click)="toggleColor(option)">

                <div class="_color-image-container">
                    @if(option | optionImage : attributeCode) {
                    <div class="w-12 height-100 p-a">
                        <img class="_color-image"
                             [dfImage]="option | optionImage : attributeCode"
                             [width]="66"
                             [height]="66"
                             [ratio]="1"
                             [maxSize]="66">
                    </div>
                    } @else {
                    <div class="_color-placeholder"
                         [style.background-color]="(option | optionColor : attributeCode) || '#ffffff'">
                        <span class="h2">{{((option | optionLabel : attributeCode) ||
                            '')?.toString()?.charAt(0)}}</span>
                    </div>
                    }
                </div>

                <div class="p2 m-t-5">
                    <span>{{option | optionLabel : attributeCode}}</span>
                </div>

                <!-- Selection indicator -->
                <div class="_optionTick">
                    <i class="icon-tick"></i>
                </div>
            </div>
        </ng-template>
        }
    </swiper>
</div>
}
